import { render } from "./setembro.vue?vue&type=template&id=d0ef8a18"
import script from "./setembro.vue?vue&type=script&lang=js"
export * from "./setembro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__